import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

// Status options for orders
const statusOptions = {
  processing: "جاري التجهيز",
  shipped: "تم الشحن",
  delivered: "تم التوصيل",
  pending: "معلق",
  cancelled: "ملغي",
};

// ✅ Fetch all orders
export const fetchOrders = createAsyncThunk(
  "orders/fetchAll",
  async (_, thunkAPI) => {
    try {
      const response = await api.get("/admin/order");
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ✅ Export orders (returns direct download URL)
export const exportOrders = createAsyncThunk(
  "orders/export",
  async (filters, thunkAPI) => {
    try {
      const { start_date, end_date, status } = filters;
      let url = "/admin/order/export?";

      if (status) url += `status=${status}&`;
      if (start_date) url += `start_date=${start_date}&`;
      if (end_date) url += `end_date=${end_date}&`;

      const response = await api.get(url);
      console.log("Exported orders response:", response.data.data.url);

      const Url = response.data?.data?.url || response.data?.url;
      return Url;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ✅ Update order status
export const updateOrderStatus = createAsyncThunk(
  "orders/updateStatus",
  async ({ id, status }, thunkAPI) => {
    try {
      const formData = new FormData();
      formData.append("_method", "put");
      formData.append("status", status);

      const response = await api.post(`/admin/order/${id}`, formData);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ✅ Slice
const ordersSlice = createSlice({
  name: "orders",
  initialState: {
    items: [],
    loading: false,
    error: null,
    statusOptions,

    // 🟦 Export related state
    exportUrl: null,
    loadingExport: false,
    exportError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 🔄 Fetch orders
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 📤 Export orders
      .addCase(exportOrders.pending, (state) => {
        state.loadingExport = true;
        state.exportError = null;
        state.exportUrl = null;
      })
      .addCase(exportOrders.fulfilled, (state, action) => {
        state.loadingExport = false;
        state.exportUrl = action.payload;
      })
      .addCase(exportOrders.rejected, (state, action) => {
        state.loadingExport = false;
        state.exportError = action.payload;
      })

      // 🔁 Update order status
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        const updatedOrder = action.payload;
        const index = state.items.findIndex(
          (order) => order.id === updatedOrder.id
        );
        if (index !== -1) {
          state.items[index] = updatedOrder;
        }
      });
  },
});

export default ordersSlice.reducer;
